import script from "./AIChatDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AIChatDialog.vue?vue&type=script&setup=true&lang=js"

import "./AIChatDialog.vue?vue&type=style&index=0&id=49ed3ea1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49ed3ea1"]])

export default __exports__